import HttpService from "./htttp.service";

class NotificationsServices {
  markNotificationAsRead = async (query, payload) => {
    const endpoint = "notifications/" + query;
    return await HttpService.put(endpoint, payload);
  };

  markAllNotificationsAsRead = async (payload) => {
    const endpoint = "notifications/read-all";
    return await HttpService.put(endpoint, payload);
  };

  getNotifications = async (query) => {
    const endpoint = "notifications";
    return await HttpService.get(endpoint, query);
  };

  getNotificationTemplates = async (query, payload) => {
    const endpoint = "notifications/templates";
    return await HttpService.get(endpoint, payload);
  };
}

export default new NotificationsServices();
